import api from "./api";
/**
 * 俱乐部活动管理
*/
// 活动列表
export const activityList = params => {
  return api('post', `/v1/management/flag-activity/list`, params);
};

// 活动城市列表
export const cityList = params => {
  return api('get', `/v1/management/flag-activity/cities`, params);
};

// 活动详情
export const activityDetail = activityId => {
  return api('get', `/v1/management/flag-activity/detail/${activityId}`);
};

// 活动保存并改为已发布
export const addFlagActivity = params => {
  return api('post', `/v1/management/flag-activity/addFlagActivity`, params);
};

// 拒绝审核
export const refuseId = activityId => {
  return api('get', `/v1/management/flag-activity/refuse/${activityId}`);
};

// 取消活动
export const cancelId = activityId => {
  return api('get', `/v1/management/flag-activity/cancel/${activityId}`);
};

// 查询活动二维码
export const qrcodeId = activityId => {
  return api('get', `/v1/management/flag-activity/qrcode/${activityId}`);
};

/**
 * 俱乐部列表管理
*/
// 俱乐部列表
export const clubList = params => {
  return api('post', `/v1/management/flag-club/list`, params);
};

// 俱乐部详情
export const clubDetail = params => {
  return api('get', `/v1/management/flag-club/detail`, params);
};

// 新增俱乐部
export const clubAdd = params => {
  return api('post', `/v1/management/flag-club/add`, params);
};

// leader信息搜索
export const searchLeader = params => {
  return api('get', `/v1/management/flag-club/search-leader`, params);
};

// 编辑俱乐部
export const clubEdit = params => {
  return api('post', `/v1/management/flag-club/edit`, params);
};

// 官方活动列表展示
export const officialActivityList = params => {
  return api('post', `/v1/management/flag-official-activity/list`, params);
};

// 官方活动详情
export const officialActivityDetail = (id, params) => {
  return api('get', `/v1/management/flag-official-activity/detail/${id}`, params);
};

// 官方编辑活动
export const officialActivityEdit = params => {
  return api('post', `/v1/management/flag-official-activity/edit`, params);
};

// 官方新增活动
export const officialActivityAdd = params => {
  return api('post', `/v1/management/flag-official-activity/add`, params);
};

// 官方发布活动
export const officialActivityPublish = params => {
  return api('get', `/v1/management/flag-official-activity/publish`, params);
};

// 官方删除活动
export const officialActivityDelate = (id, params) => {
  return api('get', `/v1/management/flag-official-activity/delete/${id}`, params);
};

// 官方查询活动二维码
export const officialActivityQrcode = (id, params) => {
  return api('get', `/v1/management/flag-official-activity/qrcode/${id}`, params);
};

// 官方查询活动城市列表
export const officialActivityCity = params => {
  return api('get', `/v1/management/flag-official-activity/cities`, params);
};

// 搜索关联活动
export const officialRelatedActivitySearch = params => {
  return api('post', `/v1/management/flag-official-activity/related-activity/search`, params);
};

// 关联活动banner默认图
export const officialRelatedActivityBanner = () => {
  return api('get', `/v1/management/flag-official-activity/related-activity/banner`);
};

// 官方导出报名名单
export const officialActivityExportEnrollmentList = (id, params) => {
  return api('get', `/v1/management/flag-official-activity/exportEnrollmentList/${id}`, {},
    {
      responseType: "blob",
    }, params);
};

// 官方导出身份证信息表
export const officialActivityExampleExportTheIDCardInformationTable = (id, params) => {
  return api('get', `/v1/management/flag-official-activity/exampleExportTheIDCardInformationTable/${id}`, {},
    {
      responseType: "blob",
    }, params);
};

// 官方上传球队名单
export const officialActivityUploadTheTeamList = (params) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api('post', `/v1/management/flag-official-activity/UploadTheTeamList`, params, config);
};

// 导出身份证信息表
export const flagActivityExampleExportTheIDCardInformationTable = (id, params) => {
  return api('get', `/v1/management/flag-activity/exampleExportTheIDCardInformationTable/${id}`, {},
    {
      responseType: "blob",
    }, params);
};

// 获取flag活动图片配置
export const getImageConfig = () => {
  return api('get', `/v1/management/flag-activity/image-config`);
};

// 保存flag活动图片配置
export const saveImageConfig = params => {
  return api('post', `/v1/management/flag-activity/image-config`, params);
};

// 俱乐部创建申请列表
export const clubApplyList = params => {
  return api('post', `/v1/management/flag-club/creation-apply-list`, params);
};

// 俱乐部创建申请详情
export const clubApplyDetail = id => {
  return api('get', `/v1/management/flag-club/creation-apply-detail?id=${id}`);
};

// 审批俱乐部创建申请
export const approvalClubApply = params => {
  return api('post', `/v1/management/flag-club/creation-apply-approve`, params);
};

// 到处待审核名单
export const exportEnrollmentList = (params) => {
  return api('get', `/v1/management/flag-club/creation-apply-export`, {},
    {
      responseType: "blob",
    }, params);
};
